import get from 'lodash.get';
import angular from 'angular';
import formStarterData from '../data/formStarterData.json';
import formStarterDataMinimal from '../data/formStarterDataMinimal.json';
import moment from 'moment';

ApplicationService.$inject = ['$http', '$q', '$window'];

function ApplicationService ($http, $q, $window) {
  var servicesUrl = $window._env.services;
  var servicesPrefix = $window._env.servicesPrefix;
  // var currentSite = $window._env.state;
  var currentSite = 'mn';
  if (window.location.host.indexOf('deltadentalne') > -1) {
    currentSite = 'ne';
  }

  this.data = formStarterData;

  this.getCurrentSite = function () {
    return currentSite;
  };

  this.getData = function () {
    return angular.copy(this.data);
  }.bind(this);

  this.getBaseData = function (previouslyAppointed) {
    var starterData = previouslyAppointed ? formStarterDataMinimal : formStarterData;
    return angular.copy(starterData);
  };

  this.setData = function (data, shouldSetBaseData) {
    if (shouldSetBaseData) {
      this.data = this.getBaseData(data.previouslyAppointed);
    }
    angular.extend(this.data, data);
  }.bind(this);

  this.submit = function (finalized) {
    var url = servicesUrl + servicesPrefix + '/appointment/application';
    if (this.data.previouslyAppointed) {
      url = servicesUrl + servicesPrefix + '/appointment/payPacket';
    }
    if (this.data.transactionID) {
      url += '/' + encodeURIComponent(this.data.transactionID);
    }
    var method = 'POST';
    var data = {};
    data.transactionID = this.data.transactionID;
    data.brokerExternalID = this.data.brokerExternalID;
    data.generalAgencyName = this.data.agencyInformation.generalAgencyName;
    data.agencyInformation = this.data.agencyInformation;
    data.brokerInformation = this.data.brokerInformation;
    data.commissionInformation = this.data.commissionInformation;
    data.declarations = this.data.declarations;
    data.selectedStates = this.data.selectedStates;
    data.createdDate = this.data.createdDate;
    data.modifiedDate = this.data.modifiedDate;
    data.finalized = finalized;
    return $http({
      url: url,
      method: method,
      data: data
    }).then(function (response) {
      if (response.data.transactionID) {
        this.data.transactionID = response.data.transactionID;
        this.data.createdDate = response.data.createdDate;
        this.data.modifiedDate = response.data.modifiedDate;
      }
    }.bind(this));
  }.bind(this);

  this.validateNpn = function (npn) {
    // for testing only
    //var url = 'http://localhost:3005/appointment/validateNPN';
    var url = servicesUrl + '/svc3005/appointment/validateNPN';
    return $q(function (resolve, reject) {
      $http({
        url: url,
        method: 'GET',
        params: {
          'npn': npn
        }
      }).then(function (response) {
        if (response.data && response.data.status === 'NOT-IN-SALESFORCE') {
          resolve(response.data);
        } else {
          reject(response.data);
        }
      }, function (response) {
        reject(response.data);
      });
    });
  };

  this.npnInSalesforce = function (npn) {
    // for testing only
    var url = servicesUrl + '/svc3005/appointment/npnInSalesforce';
    return $q(function (resolve, reject) {
      $http({
        url: url,
        method: 'GET',
        params: {
          'npn': npn
        }
      }).then(function (response) {
        if (response.data && response.data.status === 'IN-SALESFORCE') {
          resolve(response.data);
        } else {
          reject(response.data);
        }
      }, function (response) {
        reject(response.data);
      });
    });
  };

  /*
  * Generates new array of licenses based on selected states + state of residence if it wasn't selected,
  * while also keeping existing license data
  */
  this.generateLicenses = function (existingLicenses, stateOfResidence, isAgency) {
    existingLicenses = existingLicenses || []; // hacky
    var today = new Date();
    var selectedStates = angular.copy(this.data.selectedStates);
    if (stateOfResidence) {
      selectedStates[stateOfResidence] = stateOfResidence;
    }
    var selectedStatesArray = [];
    Object.keys(selectedStates).forEach(function (state) {
      if (selectedStates[state] !== false) {
        selectedStatesArray.push(state);
      }
    });
    var updatedLicenses = [];
    var licensesMap = {};
    existingLicenses.forEach(function (license) {
      licensesMap[license.state] = license;
    });
    selectedStatesArray.forEach(function (selectedState) {
      // var minExpirationDate = moment(today).format('YYYY-MM-DD');
      var maxExpirationDate = moment().add('30', 'months').format('YYYY-MM-DD');
      var dateRequired = true;

      if (selectedState === stateOfResidence && !existingLicenses[selectedState]) {
        // minExpirationDate = '1969-12-31';
        maxExpirationDate = '2099-01-01';
      }
      var license = licensesMap[selectedState];
      if (!license) {
        license = {
          'number': '',
          'expirationDate': null,
          'minExpirationDate': today,
          'maxExpirationDate': maxExpirationDate,
          'state': selectedState,
          'dateRequired': dateRequired
        };
      }
      updatedLicenses.push(license);
    });
    return updatedLicenses;
  }.bind(this);

  this.getHtmlUrl = function (options) {
    var url = servicesUrl + '/svc9000/finder/pdf/applicationAsHTML';
    url += '?transactionId=' + encodeURIComponent(this.data.transactionID);
    if (options) {
      url += '&pageName=' + encodeURIComponent(options.pageName);
    }
    return url;
  }.bind(this);

  this.getPdfUrl = function (options) {
    var url = servicesUrl;

    if (this.data.previouslyAppointed) {
      url += '/svc9000/finder/pdf/payPacketAsPDF';
    } else {
      url += '/svc9000/finder/pdf/applicationAsPDF';
    }

    url += '?transactionId=' + encodeURIComponent(this.data.transactionID);
    if (options) {
      url += '&pageName=' + encodeURIComponent(options.pageName);
    }
    return url;
  }.bind(this);

  /**
  * Resolves successfully if exact match is found
  * Rejects if address is not an exact match (sometimes with a list of addresses).
  **/

  this.validateAddress = function (enteredAddress) {
    var address = angular.copy(enteredAddress);
    if (typeof address.address2 === 'undefined') {
      address.address2 = '';
    }
    return $q(function (resolve, reject) {
      var url = servicesUrl + '/svc3007/validate/address';
      return $http({
        url: url,
        params: {
          addressLine1: address.address,
          addressLine2: address.address2,
          city: address.city,
          state: address.state,
          zip: address.zipCode
        }
      }).then(function (response) {
        var addressMatches = false;
        var addresses = [];
        var uspsAddresses = get(response, 'data.validatedAddress');
        if (!uspsAddresses.length) {
          addressMatches = false;
        }
        var returnText = '';
        if (uspsAddresses) {
          if (addressMatches) {
            return;
          }
          var address1 = get(uspsAddresses, 'Address1') || '';
          var address2 = get(uspsAddresses, 'Address2') || '';
          var city = get(uspsAddresses, 'City') || '';
          var state = get(uspsAddresses, 'State') || '';
          var zipCode = get(uspsAddresses, 'Zip5') || '';
          returnText = get(uspsAddresses, 'ReturnText') || '';
          addressMatches = (
            address.address.toUpperCase() === address1 &&
            address.address2.toUpperCase() === address2 &&
            address.city.toUpperCase() === city &&
            address.state.toUpperCase() === state &&
            address.zipCode === zipCode
          );
          addresses.push({
            address: address,
            address2: address2,
            city: city,
            state: state,
            zipCode: zipCode
          });
        }
        if (!addresses) {
          reject({
            enteredAddress: address,
            addresses: addresses,
            addressMatches: false,
            returnText: returnText
          });
        } else {
          resolve({
            enteredAddress: address,
            addresses: addresses,
            addressMatches: true,
            returnText: ''
          });
        }
      }, function (response) {
        reject({
          enteredAddress: address,
          addresses: [],
          addressMatches: false,
          returnText: ''
        });
      });
    });
  };
}

export default ApplicationService;



//////////////////
// WEBPACK FOOTER
// ./src/js/services/ApplicationService.js
// module id = 34
// module chunks = 0